import { hostExternoPermitido, hostPermitido } from './remote-config.allowlist';
import { IRemoteConfigPayload, SCHEMA_VERSION } from './remote-config.types';

const ehObjeto = (v: unknown): v is Record<string, unknown> =>
  typeof v === 'object' && v !== null && !Array.isArray(v);

/**
 * Devolve true só quando o payload INTEIRO é confiável. A rejeição é
 * tudo-ou-nada de propósito: aplicar apenas a parte válida deixaria o app meio
 * migrado, um estado mais difícil de diagnosticar do que a falha limpa.
 */
export function validarPayload(entrada: unknown): entrada is IRemoteConfigPayload {
  if (!ehObjeto(entrada)) return false;
  if (entrada['schemaVersion'] !== SCHEMA_VERSION) return false;
  if (!ehObjeto(entrada['flags']) || !ehObjeto(entrada['gates'])) return false;

  const config = entrada['config'];
  if (!ehObjeto(config)) return false;

  const hosts = config['hosts'];
  if (!ehObjeto(hosts) || Object.keys(hosts).length === 0) return false;
  for (const valor of Object.values(hosts)) {
    if (typeof valor !== 'string' || !hostPermitido(valor)) return false;
  }

  const urls = config['urls'];
  if (!ehObjeto(urls) || Object.keys(urls).length === 0) return false;
  for (const valor of Object.values(urls)) {
    if (typeof valor !== 'string') return false;
    try {
      const parsed = new URL(valor);
      if (parsed.protocol !== 'https:') return false;
      if (!hostPermitido(parsed.hostname)) return false;
    } catch {
      return false;
    }
  }

  const externalUrls = config['externalUrls'];
  if (!ehObjeto(externalUrls) || Object.keys(externalUrls).length === 0) return false;
  for (const valor of Object.values(externalUrls)) {
    if (typeof valor !== 'string') return false;
    try {
      const parsed = new URL(valor);
      if (parsed.protocol !== 'https:') return false;
      if (!hostExternoPermitido(parsed.hostname)) return false;
    } catch {
      return false;
    }
  }

  const braspag = config['braspag'];
  if (!ehObjeto(braspag)) return false;
  if (typeof braspag['providerMerchantId'] !== 'string') return false;
  if (typeof braspag['providerOrgId'] !== 'string') return false;

  const codes = config['successCodesCheckout'];
  if (!Array.isArray(codes) || codes.length === 0) return false;
  if (!codes.every((c) => typeof c === 'string')) return false;

  return true;
}
